import { render, staticRenderFns } from "./ErrorFetchingData.vue?vue&type=template&id=cc787956&scoped=true&"
import script from "./ErrorFetchingData.vue?vue&type=script&lang=ts&"
export * from "./ErrorFetchingData.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorFetchingData.vue?vue&type=style&index=0&id=cc787956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc787956",
  null
  
)

export default component.exports